import { PROVISIONING_TARGET_STATUS, TEMPLATE_PROVISIONING_TARGET } from '../servicebus/template-provisioning';
import { TEMPLATE_CONFIGURATION_STATUS } from '../template-configuration/template-configuration.interface';
import type { TemplateConfiguration } from '../template-configuration/template-configuration.interface';
import { baseDocumentFactory } from './base-document.factory';
import { ObjectFactory } from './object.factory';

export class TemplateConfigurationFactory extends ObjectFactory<TemplateConfiguration> {
  protected getDefaults(): TemplateConfiguration {
    return {
      ...baseDocumentFactory.build(),
      status: TEMPLATE_CONFIGURATION_STATUS.PENDING,
      templateId: 'template-id-1',
      values: {},
    };
  }

  /** Returns a config where provisioning has been dispatched (both targets pending). */
  buildProvisioning(): TemplateConfiguration {
    return this.build({
      provisioning: {
        incoming: { status: PROVISIONING_TARGET_STATUS.PENDING },
        outgoing: { status: PROVISIONING_TARGET_STATUS.PENDING },
      },
      status: TEMPLATE_CONFIGURATION_STATUS.PENDING,
    });
  }

  /** Returns a fully provisioned active config (both targets succeeded). */
  buildActive(): TemplateConfiguration {
    return this.build({
      provisioning: {
        [TEMPLATE_PROVISIONING_TARGET.INCOMING]: {
          status: PROVISIONING_TARGET_STATUS.SUCCESS,
        },
        [TEMPLATE_PROVISIONING_TARGET.OUTGOING]: {
          status: PROVISIONING_TARGET_STATUS.SUCCESS,
        },
      },
      status: TEMPLATE_CONFIGURATION_STATUS.ACTIVE,
    });
  }

  /** Returns a config where one or more targets failed (overall status resets to pending for retry). */
  buildFailed(): TemplateConfiguration {
    return this.build({
      provisioning: {
        [TEMPLATE_PROVISIONING_TARGET.INCOMING]: {
          error: 'Upstream service unavailable',
          status: PROVISIONING_TARGET_STATUS.FAILED,
        },
        [TEMPLATE_PROVISIONING_TARGET.OUTGOING]: {
          status: PROVISIONING_TARGET_STATUS.SUCCESS,
        },
      },
      status: TEMPLATE_CONFIGURATION_STATUS.PENDING,
    });
  }
}

export const templateConfigurationFactory = new TemplateConfigurationFactory();
